import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-ExportNotification',
	section: 'c-ExportNotificaion__section',
	title: 'c-ExportNotification__title',
	content: 'c-ExportNotification__content',
	modal: 'c-ExportNotification__modal',
};

export const Style = {
	[CSS.container]: {
		color: DefaultTheme.font.color.primary,
	},
	[CSS.section]: {
		'padding-bottom': DefaultTheme.space(1),
	},
	[CSS.title]: {
		'font-weight': DefaultTheme.font.weight.bold,
	},
	[CSS.content]: {
		'list-style': 'none',
		margin: 0,
	},
	[CSS.modal]: {
		'min-width': '650px',
	},
};
